<template>
  <div class="snackbar">
    <div class="snackbar__container">
      <div
        @click="onClickDismiss"
        class="flex h-full cursor-pointer items-center p-1"
      >
        <Icon
          icon="cross"
          size="xl"
        />
      </div>

      <div class="p-2 pl-3">
          <div class="text-base font-bold">{{ snackbar.title || '' }}</div>
          <div v-html="snackbar.message || ''"></div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { useSnackbar } from '~~/stores/snackbar';
  import { Icon } from '@skillstown/leap';

  const snackbar = useSnackbar();

  function onClickDismiss(): void {
    snackbar.closeSnackbar();
  }
</script>

<style lang="postcss" scoped>
  .snackbar {
    @apply fixed left-0 bottom-0 flex w-full items-center justify-center;
    z-index: 160;

    .snackbar__container {
      @apply mb-2 flex w-full max-w-lg items-center rounded-md text-sm text-white shadow-2xl;

      min-height: 75px;
      background-color: var(--color-brand);

      -webkit-box-shadow: -2px 5px 8px 2px rgba(0, 0, 0, 0.25);
      box-shadow: -2px 5px 8px 2px rgba(0, 0, 0, 0.25);

      .icon {
        color: white;
      }
    }
  }
</style>
